import { BackendApi } from '@/services/backend_api'

export default {
  post (senderName, senderEmail, contactSubject, contactMessage, recaptchaToken) {
    return BackendApi.getAnonymousClient()
      .post('contact', {senderName, senderEmail, contactSubject, contactMessage, recaptchaToken})
      .then(response => {
        return response
      })
      .catch(e => {
        throw e
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/contact.js